var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrag2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A9B6C4",
  fillRule: "evenodd",
  d: "M2.25 4.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M2.25 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M2.25 18a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M11.25 4.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M11.25 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M11.25 18a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
  clipRule: "evenodd"
})));
export { SvgDrag2 as ReactComponent };
export default __webpack_public_path__ + "static/media/drag2.dbe12150.svg";